export const getPropsColumn = (pole) => {
  let propsColumns = [];
  if (pole) {
    pole.map((el) => {
      let colomn = {
        field: el.label,
        headerName: el.label,
        width: 140,
        editable: true,
      };
      propsColumns.push(colomn);
    });
  }
  const columns = [
    ...[{ field: "id", headerName: "Название", width: 140, editable: false }],
    ...propsColumns,
  ];

  return columns;
};

export const getPropsRow = (pole) => {
  let propsRows = {};
  if (pole) {
    pole.map((el) => {
      let row = {
        [el.label]: el.type,
      };
      propsRows = { ...propsRows, ...row };
    });
  }
  const rows = [{ id: "Тип элемента", ...propsRows }];

  return rows;
};
